/**
 * Módulo compartilhado da calculadora de frete.
 *
 * Fonte única para o que as TRÊS superfícies de cotação precisam ter em comum:
 * PDP (assets/product-shipping-estimator.js), cart drawer e /cart (ambos via
 * assets/cart.js). Carregado uma única vez em layout/theme.liquid, logo após
 * theme.js: scripts `defer` executam na ordem do documento, então este roda
 * depois de theme.js (de quem depende: FoxTheme.Currency/FoxTheme.settings) e
 * antes de todo script de section.
 */
window.ADCFrete = (function () {
  'use strict';

  // Faixas oficiais de CEP -> UF (mesma tabela do servidor de frete).
  const ADC_FAIXAS_UF = [
    ['AC',69900000,69999999],['AL',57000000,57999999],['AM',69000000,69299999],['AM',69400000,69899999],
    ['AP',68900000,68999999],['BA',40000000,48999999],['CE',60000000,63999999],['DF',70000000,72799999],
    ['DF',73000000,73699999],['ES',29000000,29999999],['GO',72800000,72999999],['GO',73700000,76799999],
    ['MA',65000000,65999999],['MG',30000000,39999999],['MS',79000000,79999999],['MT',78000000,78899999],
    ['PA',66000000,68899999],['PB',58000000,58999999],['PE',50000000,56999999],['PI',64000000,64999999],
    ['PR',80000000,87999999],['RJ',20000000,28999999],['RN',59000000,59999999],['RO',76800000,76999999],
    ['RO',78900000,78999999],['RR',69300000,69399999],['RS',90000000,99999999],['SC',88000000,89999999],
    ['SE',49000000,49999999],['SP',1000000,19999999],['TO',77000000,77999999]
  ];

  function adcUfDoCep(v) {
    const n = parseInt(String(v).replace(/\D/g, ''), 10);
    if (isNaN(n)) return '';
    for (const [uf, ini, fim] of ADC_FAIXAS_UF) { if (n >= ini && n <= fim) return uf; }
    return '';
  }

  // Os nomes de transportadora e os textos de prazo vêm de um carrier service de
  // terceiro (LucroFrete) e são injetados via innerHTML pelas duas superfícies.
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /**
   * Formata um valor de frete vindo de qualquer uma das duas APIs.
   *
   * A AJAX API devolve "118.40" e a Storefront API devolve o Decimal "118.4" —
   * medido em produção, mesma tarifa (RODONAVES). A conversão é NUMÉRICA de
   * propósito: FoxTheme.Currency.formatMoney recebendo a string crua faz
   * cents.replace('.','') (assets/theme.js:426-428) e transformaria "118.4" em
   * "1184" -> R$ 11,84. Erro de 10x.
   */
  function formatarFrete(valor) {
    const n = parseFloat(String(valor).replace(',', '.'));
    if (!isFinite(n)) return '';
    return FoxTheme.Currency.formatMoney(Math.round(n * 100), FoxTheme.settings.moneyFormat);
  }

  // CEP compartilhado entre as superfícies dentro da MESMA aba/sessão.
  // sessionStorage, não localStorage: o CEP é contexto de uma visita, não uma
  // preferência duradoura, e uma cotação é volátil (medimos a mesma tarifa
  // mudar ao longo do dia) — não deve sobreviver ao fechamento da aba.
  const CHAVE_CEP = 'adc_cep';

  function lerCep() {
    try { return sessionStorage.getItem(CHAVE_CEP) || ''; } catch (e) { return ''; }
  }

  function gravarCep(cep) {
    try { sessionStorage.setItem(CHAVE_CEP, cep); } catch (e) { /* modo privado */ }
  }

  return {
    adcUfDoCep: adcUfDoCep,
    escapeHtml: escapeHtml,
    formatarFrete: formatarFrete,
    lerCep: lerCep,
    gravarCep: gravarCep
  };
})();

// Compatibilidade: a derivação de UF era global (definida em assets/cart.js).
window.adcUfDoCep = window.ADCFrete.adcUfDoCep;
